import React, { useState, useEffect } from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import "./nosotros.css"
import DomoticNavbar from '../Components/Navbar';

const NosotrosPage = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const handleSlideChange = (index) => {
    setCurrentSlide(index);
  };

  // Datos del equipo
  const equipo = [
    {
      id: 1,
      nombre: "",
      cargo: "CEO & Fundador",
      imagen: "https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80",
      descripcion: "Más de 20 años de experiencia en el sector tecnológico."
    },
    {
      id: 2,
      nombre: "",
      cargo: "Directora de Operaciones",
      imagen: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80",
      descripcion: "Especialista en gestión de proyectos y procesos."
    },
    {
      id: 3,
      nombre: "",
      cargo: "Gerente Técnico",
      imagen: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80",
      descripcion: "Ingeniero con amplia experiencia en desarrollo de soluciones."
    },
    {
      id: 4,
      nombre: "",
      cargo: "Líder de Proyectos",
      imagen: "https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80",
      descripcion: "PMO certificada con más de 10 años en gestión de equipos."
    },
    {
      id: 5,
      nombre: "",
      cargo: "Técnico Senior",
      imagen: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80",
      descripcion: "Especialista en implementación de soluciones técnicas."
    },
    {
      id: 6,
      nombre: "",
      cargo: "Técnico Junior",
      imagen: "https://images.unsplash.com/photo-1554151228-14d9def656e4?ixlib=rb-1.2.1&auto=format&fit=crop&w=300&q=80",
      descripcion: "Recién graduada con gran potencial y habilidades técnicas."
    }
  ];

  // Partners
  const partners = [
    { id: 1, nombre: "TechGlobal", logo: "https://via.placeholder.com/150x80?text=TechGlobal" },
    { id: 2, nombre: "InnovaSolutions", logo: "https://via.placeholder.com/150x80?text=InnovaSolutions" },
    { id: 3, nombre: "DigitalMind", logo: "https://via.placeholder.com/150x80?text=DigitalMind" },
    { id: 4, nombre: "FutureTech", logo: "https://via.placeholder.com/150x80?text=FutureTech" },
    { id: 5, nombre: "CloudSystems", logo: "https://via.placeholder.com/150x80?text=CloudSystems" }
  ];

  return (
    <div className={`nosotros-container ${isVisible ? 'fade-in' : ''}`}>
    <DomoticNavbar/>
      <section className="hero-section">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>NOSOTROS</h1>
          <p>Conoce más sobre nuestra historia, valores y el equipo que hace posible nuestra visión</p>
        </div>
      </section>

      <section className="carousel-section">
        <div className="section-header">
          <h2>Nuestra Esencia</h2>
          <div className="divider"></div>
        </div>
        
        <Carousel 
          showArrows={true} 
          showThumbs={false} 
          showStatus={false} 
          autoPlay={true} 
          interval={6000} 
          infiniteLoop={true} 
          selectedItem={currentSlide} 
          onChange={handleSlideChange}
          className="custom-carousel"
        >
          <div className="carousel-slide">
            <div className="slide-content">
              <h3>Misión</h3>
              <p>Ofrecemos soluciones tecnológicas innovadoras y sostenibles que automatizan, protegen y transforman espacios corporativos y residenciales. En Domotic Control, combinamos inteligencia artificial, energía limpia,  altos estándares técnicos y un equipo comprometido para garantizar la eficiencia, seguridad y satisfacción de nuestros clientes.</p>
            </div>
          </div>
          <div className="carousel-slide">
            <div className="slide-content">
              <h3>Visión</h3>
              <p>Ser referentes en el ecosistema tecnológico de la región, liderando el desarrollo e implementación de soluciones TIC que conecten personas, organizaciones y espacios inteligentes con eficiencia, responsabilidad ambiental y alto valor técnico</p>
            </div>
          </div>
          <div className="carousel-slide">
            <div className="slide-content">
              <h3>Valores Corporativos</h3>
              <p>
Innovación Continua: Impulsamos el cambio tecnológico mediante soluciones creativas y de vanguardia que responden a las necesidades cambiantes del mercado.
Excelencia Técnica: Garantizamos altos estándares de calidad en cada proyecto, con ingeniería precisa y tecnología confiable.
Responsabilidad Ambiental: Desarrollamos soluciones sostenibles, promoviendo el uso de energía limpia y prácticas responsables con el entorno.
Orientación al Cliente: Escuchamos, entendemos y acompañamos a nuestros clientes con un enfoque personalizado y humano en cada etapa del servicio.
Confianza y Transparencia: Actuamos con integridad y claridad, generando relaciones sólidas y duraderas con nuestros clientes y aliados.
Compromiso con la Transformación Digital: Conectamos a empresas y hogares con el futuro, integrando tecnologías inteligentes que optimizan procesos y mejoran la calidad de vida</p>
            </div>
          </div>
        </Carousel>
        
        <div className="carousel-indicators">
          {['Misión', 'Visión', 'Fundación'].map((item, index) => (
            <button 
              key={index} 
              className={`indicator ${currentSlide === index ? 'active' : ''}`}
              onClick={() => handleSlideChange(index)}
            >
              {item}
            </button>
          ))}
        </div>
      </section>

   

    </div>
  );
};

export default NosotrosPage;